import { CogIcon, LinkIcon, EnvelopeIcon } from '@sanity/icons'

export default (S) =>
    S.list()
        .title('Content')
        .items([
            S.listItem()
                .title('Home Page')
                .child(
                    S.list()
                        .title('Home Page Sections')
                        .items([
                            S.documentListItem().id('heroSection').title('Hero Section').schemaType('heroSection'),
                            S.documentListItem().id('aboutSection').title('About Section').schemaType('aboutSection'),
                            S.documentListItem().id('founderSection').title('Founder Section').schemaType('founderSection'),
                            S.documentListItem().id('servicesSectionId').title('Services Section').schemaType('servicesSectionId'),
                            S.documentListItem().id('testimonialSection').title('Testimonial Section').schemaType('testimonialSection'),
                            S.documentListItem().id('whyChooseUsSectionId').title('Why Choose Us Section').schemaType('whyChooseUsSectionId'),
                        ])
                ),
            S.listItem()
                .title('About Us Page')
                .child(
                    S.list()
                        .title('About Us Sections')
                        .items([
                            S.documentListItem().id('aboutUsFounderSection').title('Founder Section').schemaType('aboutUsFounderSection'),
                            S.documentListItem().id('aboutUsAboutSection').title('About Section').schemaType('aboutUsAboutSection'),
                            S.documentListItem().id('aboutUsTeamSection').title('Team Section').schemaType('aboutUsTeamSection'),
                            S.documentListItem().id('aboutUsWhatWeDoSectionID').title('What We Do Section').schemaType('aboutUsWhatWeDoSectionID'),
                        ])
                ),
            S.listItem()
                .title('FAQ Page')
                .child(
                    S.list()
                        .title('FAQ Sections')
                        .items([
                            S.documentListItem().id('faqTitleSection').title('Title Section').schemaType('faqTitleSection'),
                            S.documentListItem().id('faqLinksSection').title('Navigation Links Section').schemaType('faqLinksSection'),
                            S.documentListItem().id('faqGroupsSectionID').title('Groups Section').schemaType('faqGroupsSectionID'),
                        ])
                ),
            S.listItem()
                .title('Our Services Page')
                .icon(CogIcon)
                .child(
                    S.document().schemaType('ourServicesId').documentId('ourServicesId')
                ),
            S.listItem()
                .title('Useful Links Page')
                .icon(LinkIcon)
                .child(
                    S.document().schemaType('usefulLinks').documentId('usefulLinks')
                ),
            S.listItem()
                .title('Contact Us Page')
                .icon(EnvelopeIcon)
                .child(
                    S.document().schemaType('contactUs').documentId('contactUs')
                ),
            S.divider(),
            S.listItem()
                .title('Components')
                .child(
                    S.list()
                        .title('Components')
                        .items([
                            S.documentListItem()
                                .id('contactSection')
                                .title('Contact Section')
                                .schemaType('contactSection')
                                .child(
                                    S.document()
                                        .schemaType('contactSection')
                                        .documentId('contactSection')
                                ),
                        ])
                ),
        ]) 